import { cn } from '../../lib/cn';
import { TrendingUp, TrendingDown } from 'lucide-react';

export function StatCard({ title, value, subtitle, icon: Icon, color='blue', trend, trendLabel, className }) {
  const colors = {
    blue:   { bg:'bg-[var(--accent-muted)]',   text:'text-[var(--accent)]'   },
    green:  { bg:'bg-[var(--success-muted)]',  text:'text-[var(--success)]'  },
    yellow: { bg:'bg-[var(--warning-muted)]',  text:'text-[var(--warning)]'  },
    red:    { bg:'bg-[var(--danger-muted)]',   text:'text-[var(--danger)]'   },
    purple: { bg:'bg-[var(--purple-muted)]',   text:'text-[var(--purple)]'   },
  };
  const c = colors[color] || colors.blue;
  return (
    <div className={cn('bg-[var(--bg-card)] border border-[var(--border)] rounded-[var(--radius-md)] shadow-[var(--shadow-sm)] p-5 flex flex-col gap-3', className)}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-[12px] font-medium text-[var(--text-secondary)] uppercase tracking-wide">{title}</p>
          <p className="text-[28px] font-bold text-[var(--text-primary)] leading-tight mt-1">{value}</p>
          {subtitle && <p className="text-[12px] text-[var(--text-tertiary)] mt-0.5">{subtitle}</p>}
        </div>
        {Icon && (
          <div className={cn('w-10 h-10 rounded-[10px] flex items-center justify-center', c.bg)}>
            <Icon size={20} className={c.text} />
          </div>
        )}
      </div>
      {(trend !== undefined) && (
        <div className="flex items-center gap-1.5">
          {trend >= 0
            ? <TrendingUp size={14} className="text-[var(--success)]" />
            : <TrendingDown size={14} className="text-[var(--danger)]" />}
          <span className={cn('text-[12px] font-medium', trend >= 0 ? 'text-[var(--success)]' : 'text-[var(--danger)]')}>
            {trend >= 0 ? '+' : ''}{trend}%
          </span>
          {trendLabel && <span className="text-[12px] text-[var(--text-tertiary)]">{trendLabel}</span>}
        </div>
      )}
    </div>
  );
}
export default StatCard;
